document.addEventListener('DOMContentLoaded', () => {

    window.addEventListener("load", () => {
        window.cookieconsent.initialise({
            "position": "floating",
            content: {
                message: 'This website uses cookies to ensure you get the best possible experience, by using this website you are agreeing to our',
                dismiss: 'Okay',
                allow: 'Allow cookies',
                deny: 'Decline',
                link: 'Cookie Policy.',
                href: '#',
                target: '_blank',
            }
        })
    });

})